<div
  class="annotation-buttons-container"
  style="display: flex; gap: 10px; align-items: center"
>
  <!-- Manual PDF Button -->
  <button
    class="btn btn-sm btn-info"
    [class.disabled]="isDownloadingManualPDF"
    (click)="openManualPDF()"
    title="Open Manual PDF"
  >
    <span *ngIf="!isDownloadingManualPDF">
      <i class="fa fa-book"></i> Manual
    </span>
    <span *ngIf="isDownloadingManualPDF">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
  </button>

  <!-- Annotation Document Button -->
  <button
    *ngIf="isPDF"
    class="btn btn-sm btn-success"
    [class.disabled]="isDownloadingAnnotationPDF"
    (click)="openAnnotationDocument()"
    title="Open Annotation PDF"
  >
    <span *ngIf="!isDownloadingAnnotationPDF">
      <i class="fa fa-file-pdf-o"></i> Annotation
    </span>
    <span *ngIf="isDownloadingAnnotationPDF">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
  </button>

  <!-- Annotation Image Link (for non-PDF annotations) -->
  <a
    *ngIf="!isPDF"
    class="btn btn-sm btn-success"
    [href]="getAnnotationImageUrl()"
    target="_blank"
    title="Open Annotation Image"
  >
    <i class="fa fa-image"></i> Annotation
  </a>
</div>
